import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { gridConfig, tokens } from '../../../../constants';
export var getGridRowStyles = (props, breakpoint) => {
  var _a;
  var config = props.config,
    noMargin = props.noMargin;
  var _ref = (config === null || config === void 0 ? void 0 : config[breakpoint]) || {},
    columnSpacing = _ref.columnSpacing;
  return StyleSheet.create({
    container: Object.assign({
      flexDirection: 'row',
      flexWrap: 'wrap'
    }, !noMargin && {
      marginHorizontal: -(((_a = tokens.spacing) === null || _a === void 0 ? void 0 : _a[columnSpacing]) / 2)
    })
  });
};
export var getGridRowProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var _ref2 = merge(gridConfig === null || gridConfig === void 0 ? void 0 : gridConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.grid) === null || _a === void 0 ? void 0 : _a[theme]) || {},
    config = _ref2.config,
    configProps = _ref2.row;
  return Object.assign(Object.assign({
    theme,
    config
  }, configProps), props);
};